import type { Tables } from '@/types/database.types'

type CompanyMembershipAttributes = Pick<
  Tables<'companies'>,
  | 'discount'
  | 'is_contact_data_enabled'
  | 'is_display_company_name_enabled'
  | 'is_market_reports_enabled'
  | 'is_marketplace_enabled'
  | 'is_offer_competition_information_enabled'
  | 'is_vehicle_packages_enabled'
  | 'is_vehicle_specifications_enabled'
>

export default function mapCompanyMembershipAttributes(
  atttributes?: CompanyMembershipAttributes
) {
  return {
    discount: atttributes?.discount || 0,
    isContactDataEnabled: atttributes?.is_contact_data_enabled || false,
    isDisplayCompanyNameEnabled:
      atttributes?.is_display_company_name_enabled || false,
    isMarketReportsEnabled: atttributes?.is_market_reports_enabled || false,
    isMarketplaceEnabled: atttributes?.is_marketplace_enabled || false,
    isOfferCompetitionInformationEnabled:
      atttributes?.is_offer_competition_information_enabled || false,
    isVehiclePackagesEnabled: atttributes?.is_vehicle_packages_enabled || false,
    isVehicleSpecificationsEnabled:
      atttributes?.is_vehicle_specifications_enabled || false,
  }
}
